import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import c from '../../config';
import { isExternalURL, parseSanitizedHTML } from '../../utils/Helper';
import './FooterSitemap.scss';

const FooterSitemap = (props) => {
  const { menuItem } = props;
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    const flattenData = (data) => {
      return data.map((v) => {
        const firstLink = {
          Type: v.Type,
          title: v.title,
          url: v.url,
        };
        let menuLevel2 = [];

        if (typeof v.menu_level_2 !== 'undefined') {
          if (v.menu_level_2 instanceof Array) {
            menuLevel2 = v.menu_level_2;
          } else if (v.menu_level_2 instanceof Object) {
            menuLevel2.push(v.menu_level_2);
          }
        }

        return { rows: [firstLink, ...(menuLevel2 || [])] };
      });
    };

    if (menuItem.length > 0) {
      setMenuList(flattenData(menuItem));
    }
  }, [menuItem]);

  const link = (item) => {
    return (
      <>
        {isExternalURL(item.url) ? (
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            {parseSanitizedHTML(item.title)}
          </a>
        ) : (
          <NavLink to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}>
            {parseSanitizedHTML(item.title)}
          </NavLink>
        )}
      </>
    );
  };

  return (
    <Container className="footerSitemap d-none d-sm-none d-md-none d-lg-block d-xl-block">
      <Row>
        <Col>
          <div className="footerSitemap--greyLine_top" />
          <div className="footerSitemap--container">
            {menuList.map((v, k) => {
              return (
                <div key={k} className="footerSitemap--container__row">
                  {v.rows.map((vv, kk) => {
                    return <div key={kk}>{link(vv)}</div>;
                  })}
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FooterSitemap; // <- For component Unit Test
